import RestService from "./rest.service";

class homeService {
  home() {
    return new Promise((fnResolve, fnReject) => {
      RestService.getHome("app/home/data").then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
}

export default new homeService();
